import type { WebChatConfiguratorConstructor } from './web-chat-configurator.types';

/**
 * Dynamically imports the Purolator WebChatConfigurator ESM from a CDN URL.
 * Uses a runtime variable (and bundler-ignore comments) so the Angular build
 * does not rewrite the remote URL. Avoids inline `<script>` injection, which
 * CSP `script-src` blocks when `'unsafe-inline'` is absent.
 *
 * @param url Absolute ESM URL for staging or production Purolator configurator.
 * @returns The `WebChatConfigurator` constructor exported by the CDN module.
 */
export async function importWebChatConfiguratorFromCdn(
  url: string,
): Promise<WebChatConfiguratorConstructor> {
  const moduleUrl: string = url;
  const mod = (await import(/* @vite-ignore */ /* webpackIgnore: true */ moduleUrl)) as {
    WebChatConfigurator?: WebChatConfiguratorConstructor;
  };
  const ctor = mod.WebChatConfigurator;
  if (!ctor) {
    throw new Error('WebChatConfigurator loaded but constructor missing');
  }
  return ctor;
}
